module.exports = __webpack_public_path__ + "static/media/socialPhoneIcons.c3cb71eb.svg";